// extracted by mini-css-extract-plugin
module.exports = {"MainColor":"#1093FF","SecondaryColor":"#69BBFF","Main-bg":"#F2F4F7"};